import React, { Component } from 'react';
import BackgroundImage from '../../components/BackgroundImage';
import { connect } from 'react-redux'
import { BrowserRouter, Switch, Route, Redirect, withRouter } from "react-router-dom";
//import { withRouter } from "react-router"
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import LiveliCalendar from '../calendar';
import { getAllEvents } from '../../actions/events-actions';
import { putTicker } from "../../actions/tickers-actions";
import Settings from '../../scenes/settings/index'
import Tickers from '../../scenes/tickers/index'
import Dashboard from '../../scenes/dashboard/'
import MopinionForm from 'react-mopinion-forms';
import liveliSteps from "./stepsTutorial";
// Adding styles
import homeStyles from './main.module.scss';
import styles from '../../styles/components/header.module.scss';
import moment from 'moment';
import { getAppUser, clearState, setStep } from '../../actions/user-actions';
import userApi from '../../api/user-api';
import { interceptor } from '../../services/interceptor-service';
import Empty from '../../components/Empty';
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      showEditionModal: false,
      showReminderModal: false,
      isEditingReminder: false,
      editionEvent: {},
      showSidebar: false,
      stepsEnabled: true,
      initialStep: this.props.stepTutorial,
      steps: liveliSteps,
      hintsEnabled: true,
      moveSetting: false,
      showTutorial: true,
      openTutorial: true,
      hints: [
        {
          element: ".hello",
          hint: "Hello hint",
          hintPosition: "middle-right"
        }
      ]
    }

  }

  onBeforeChange = nextStepIndex => {
    this.props.setStep(nextStepIndex)
    if (nextStepIndex === 2) {
      this.setState({moveSetting: true})
      this.props.history.push("/settings");
    }
  }

  onExit = () => {
    this.setState({showTutorial: false})
  }


  componentDidMount() {
    this.props.getAppUser();
    this.props.getAllEvents(moment(this.props.defaultDate).format('YYYY-MM'));
    //console.log('Current Token: ' + interceptor.getValue('token'));
    
    //refresh the token
    setInterval(() => {
      //console.log('Trying to renew the token');
      try {
        userApi.refreshToken()
          .then(response => {
              const token = response.data.token;
              const accessToken = response.data.accessToken;
              //const refreshToken = response.refreshToken;
              interceptor.addValue('accessToken', accessToken);

              //Refresh token must not be updated
              //console.log('Current Token: ' + interceptor.getValue('token'));
              interceptor.addToken(token);
              //console.log('SUCCESS renew the token, new Token:' + token);
          })
          .catch(error => {
              console.log(error);
        })
      }
      catch (e) {
        console.log('ERROR, FAILED TO renew the token');
      }
      
    }, (20) * (60) * (1000));
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.errorMessage && this.props.errorMessage === 'Unauthenticated') {
      this.props.clearUserState();
      window.location.replace('/');
    }
    
    if (!this.props.loading && !localStorage.getItem('token')) {
      this.props.clearUserState();
      window.location.replace('/');
    }
  }

  toggleSidebar = () => {
    this.setState({
      showSidebar: !this.state.showSidebar
    })
  }

  openTutorial = (open) => {
    this.setState({
      openTutorial: open
    })
  }

  displayModal =(show, event) => {
    if(event){
      event = {
        ...event,
        start: moment(event.start),
        end: moment(event.end)
      }
    }
    if(!event){
      this.setState({
        showReminderModal: false,
        isEditingReminder: false,
        showEditionModal: false,
        editionEvent: {}
      })
    }
    else if(event.isReminder){
      this.setState({
        showReminderModal: show,
        isEditingReminder: true,
        showEditionModal: false,
        editionEvent: event
      })
    }
    else{
      this.setState({
        showEditionModal: show,
        editionEvent: event,
        showReminderModal: false,
        isEditingReminder: false,
      })
    }
  }

  sendmOpinion = () => {
    let data = {
      email: this.props.userProfile.email,
      sortKey: this.props.userProfile.sortKey,
      ticker: 'mOpinion'
    };
    this.props.putTicker(data);
  }

  render() {
    const { userProfile } = this.props;

    let showForm = ( !userProfile.mOpinionFeedback && userProfile.logins && userProfile.logins >= 10)
    if (!localStorage.getItem('token')) {
      window.location.replace('/');
    }
    return (
      <BackgroundImage home={true} active={this.props.showLoading}>
        <MopinionForm 
          formKey={'c35a5e48f8d21002bc574b550171c11cdcd74341'} 
          onSubmit={(e) => {
            this.sendmOpinion()
          }}
          forceOpen={showForm}
        />
        <BrowserRouter basename="/main">
          <Header 
            toggleSidebar={this.toggleSidebar} 
            displayModal={this.displayModal} 
            showEditionModal={this.state.showEditionModal} 
            openTutorial={this.openTutorial}
            editionEvent={this.state.editionEvent}
          />
          <section className={homeStyles.___core}>
          <Sidebar
              menuStyle={styles.__close}
              toggleSideBar={this.toggleSidebar}
              show={this.state.showSidebar}
              isAdmin={userProfile.isAdmin} />
            <section className={[homeStyles.___coreContent, 'hello'].join(' ')}>
              <Switch>
                {userProfile.isAdmin && 
                  <Route path='/dashboard' component={Dashboard} />
                }
                <Route path='/tickers' component={Tickers} />
                <Route path='/settings' component={Settings} />
                <Route path='/empty' component={Empty} />
                <Route path={'/calendar'} render={(props) =>
                  <LiveliCalendar
                    {...props}
                    displayModal={this.displayModal}
                    showEditionModal={this.state.showEditionModal}
                    showReminderModal={this.state.showReminderModal}
                    isEditingReminder={this.state.isEditingReminder}
                    editionEvent={this.state.editionEvent} />
                  }
                />
                  <Redirect to='/calendar' />
              </Switch>
            </section>
          </section>
        </BrowserRouter>
      </BackgroundImage>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    showLoading: state.loadingReducer.showLoading,
    loading: state.loadingReducer.showLoading,
    errorMessage: state.userReducer.errorMessage,
    defaultDate: state.userReducer.defaultDate,
    userProfile: state.userReducer.userProfile,
    stepTutorial: state.userReducer.stepTutorial
  }

}

const mapDispatchToProps = (dispatch) => {
  return {
    getAllEvents: (sort) => dispatch(getAllEvents(sort)),
    getAppUser: () => dispatch(getAppUser()),
    putTicker: userData => dispatch(putTicker(userData)),
    clearUserState: () => dispatch(clearState()),
    setStep: (step) => dispatch(setStep(step)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home))
